module.exports = __webpack_public_path__ + "static/media/writing_small.34b53652.gif";